module.exports = __webpack_public_path__ + "img/moi-sclad.149bb7b4.png";